import { createContext, useContext, useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'elhw-lang';
const LanguageContext = createContext({ isEN: false, toggle: () => {}, t: (v) => v });

export function pick(value, isEN) {
  if (value && typeof value === 'object' && !Array.isArray(value) && ('en' in value || 'ar' in value)) {
    return (isEN ? value.en : value.ar) ?? value.ar ?? value.en ?? '';
  }
  return value;
}

export function LanguageProvider({ children }) {
  const [isEN, setIsEN] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'en';
    } catch {
      return false;
    }
  });

  const toggle = useCallback(() => {
    setIsEN((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, next ? 'en' : 'ar');
      } catch {
      }
      return next;
    });
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute('dir', isEN ? 'ltr' : 'rtl');
    html.setAttribute('lang', isEN ? 'en' : 'ar');
  }, [isEN]);

  const t = useCallback((value) => pick(value, isEN), [isEN]);

  return (
    <LanguageContext.Provider value={{ isEN, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
